import React, { Component } from "react";
import { Modal, Button, FormControl } from "react-bootstrap";
import { inject, observer } from "mobx-react";
import axios from "axios";
import BaseUrl from "../../Stores/DataStore/Enums/BaseUrl";

// TODO: Move modal to separate page-component -> move api-call outside of UI
class ActivationCodeModalButton extends Component {
  constructor(props) {
    super(props);

    this.state = { showActivactionCodeModal: false, activationCode: null };

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    this.setState({ showActivactionCodeModal: false, activationCode: null });
  }

  handleShow() {
    const { userId } = this.props;

    this.setState({
      showActivactionCodeModal: true,
      activationCode: "Loading..."
    });

    const baseUrl = new BaseUrl();
    const url = baseUrl.SERVERURL + "/api/public/offline-activation-code.php/" + userId;

    axios
      .get(url)
      .then(
        async function(response) {
          if (response.data) {
            if (response && response.data) {
              this.setState({ activationCode: response.data });
            }
          }
        }.bind(this)
      )
      .catch(function(error) {
        debugger;
        if (error) {
          console.log(error);
          console.log(error.message);
        }
      });
  }

  render() {
    const { stores, userId } = this.props;

    let modal = null;

    // Show modal?
    if (this.state.showActivactionCodeModal) {
      // Username
      let userName = "";
      const user = stores.data.UsersStore.findById(userId);
      if (user) userName = user.Name;

      // Applications-list
      let applicationsList = null;
      const licenses = stores.data.LicensesInUseStore.findByOfflineAndUserId(userId);

      if (licenses) {
        applicationsList = licenses.map(licenseInUse => {
          let result = null;

          const license = stores.data.LicensesStore.findById(licenseInUse.LicenseId);

          if (license) {
            const application = stores.data.ApplicationsStore.findById(license.ApplicationId);
            result = <li key={application.Id}>{application.Name}</li>;
          }

          return result;
        });
      }

      modal = (
        <div>
          <Modal show={this.state.showActivactionCodeModal} onHide={this.handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Activation code</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>User: {userName}</p>
              <p>Activation code for:</p>
              <ul>{applicationsList}</ul>
              <div className="row">
                <div className="col-sm-12">
                  <FormControl componentClass="textarea" placeholder="activation code" value={this.state.activationCode} rows="15" readOnly />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.handleClose}>Close</Button>
            </Modal.Footer>
          </Modal>
        </div>
      );
    }

    return (
      <div>
        <Button bsStyle="primary" onClick={this.handleShow}>
          Get activation code
        </Button>
        {modal}
      </div>
    );
  }
}

export default inject("stores")(observer(ActivationCodeModalButton));



// WEBPACK FOOTER //
// ./src/Components/ActivationCodeModal/ActivationCodeModalButton.js